<script setup lang="ts">
// Overrides @basecom-gmbh/pond/components/Checkout/CheckoutCart.vue
// IDS-160: use custom vendor hint component

const { groupedCartItems, getShippingMethodCost } = useGroupedCartItems();
</script>

<template>
    <ul>
        <!-- CUSTOM IDS-79 Grouped Items by Vendor. added fees and link fields as well -->
        <template
            v-for="(group, index) in groupedCartItems"
            :key="group?.vendor?.id ?? index"
        >
            <template v-if="group?.vendor?.id">
                <h2 class="mb-1 mt-4 text-lg font-bold">
                    {{ $t('checkout.cart.soldByVendor') }}

                    <SharedVendorHint :vendor="group.vendor" />
                </h2>

                <span class="text-sm text-neutral-600">
                    {{
                        $t('checkout.cart.estimatedDelivery', {
                            time: getShippingMethodCost(group.vendor?.id).shippingDeliveryTime,
                        })
                    }}
                </span>
                <li
                    v-for="item in group.items"
                    :key="item.cartItem.id"
                    class="flex border-b border-neutral-500 py-6 pr-4"
                >
                    <CheckoutLineItem
                        v-if="item.cartItem.type !== 'promotion'"
                        :line-item="item.cartItem"
                        :product="item.product"
                    />
                </li>

                <CheckoutVendorFees
                    v-if="group.vendor"
                    :vendor="group.vendor"
                />
            </template>
        </template>
    </ul>
</template>
